// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"bb7a197b","105":"0d0846e6","213":"ac0f7aab","239":"e5c67917","285":"74f59c10","589":"33c8ea9f","636":"744e4adb","662":"c42c7713","667":"2acbc8cd","712":"2ea33ba8","808":"7a149747","811":"fe0ccd05","887":"53962f4f","977":"371834ab"}[chunkId] + ".chunk.js";
};